import store from "../../../store";
import hr_add from "./add/hr_add.vue";
import hr_user_edit from "./add/hr_user_edit.vue";
import hr_move from "./add/hr_move.vue";

window.HR =  new Vue({
    store,
    el: '#hr',
    name : "HR",
    created () {

    },

    components : {
        hr_add,
        hr_user_edit,
        hr_move
    }
})
